import { Stack } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { FormAwareSwitch } from '@/components/form/formAwareInputs/FormAwareSwitch';
import { useFormContext } from '@/components/react-hook-form/hooks';
import { FieldNameFromFormShape } from '@/types/react-hook-form';

import { SmartReviewStepFooterProps } from '../../SmartReviewOnboardingModal.types';
import { ClientSetupFormShape } from './ClientSetup.type';

/**
 * Footer for the "Basic info" step: a prospect toggle on the left and a
 * Continue button on the right. Continue submits the form (the parent validates
 * and creates the household) and then advances to the next step.
 */
export function ClientSetupFooter({ onAdvance }: SmartReviewStepFooterProps) {
  const { control, formState } = useFormContext<ClientSetupFormShape>();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
    >
      <FormAwareSwitch
        label="Mark as prospect"
        labelPosition="right"
        fieldName={`isProspect` as FieldNameFromFormShape<ClientSetupFormShape>}
        control={control}
      />
      <Button
        variant="primary"
        size="sm"
        onClick={onAdvance}
        loading={formState.isSubmitting}
      >
        Continue
      </Button>
    </Stack>
  );
}
